/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import { CoralModel, modelRegistrySingleton, } from "ihm-js-coral-client";
export class UpdatePermissionRequestOutput extends CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UpdatePermissionRequestOutput#clone(obj: PlainObjectFrom<UpdatePermissionRequestOutput>) method.
     */
    static fromJson(data) {
        return new UpdatePermissionRequestOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
UpdatePermissionRequestOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#UpdatePermissionRequestOutput";
// Register concrete types for serialization/deserialization
modelRegistrySingleton.registerType(UpdatePermissionRequestOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UpdatePermissionRequestOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
export function validateUpdatepermissionrequestoutput(data) {
    // TODO: Actually implement this!
    return data;
}
